import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-12v2',
  templateUrl: './12v2.component.html',
})
export class CuiGeneral12v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
